import { ReactElement } from 'react';
import classnames from 'classnames';

import styles from './file-name.less';

const parse = (file: File): { name: string; extension: string } => {
    const name = file.name;
    const parts = name.split('.');
    if (parts.length === 1) {
        return {
            name: parts[0],
            extension: '',
        };
    }
    const extension = parts.pop();
    return {
        // -1 из-за точки
        name: name.substring(0, name.length - (extension?.length || 0) - 1),
        extension: extension || '',
    };
};

interface FileNameProps {
    file: File;
    isSizeMedium?: boolean;
}

const FileName = ({ file, isSizeMedium = false }: FileNameProps): ReactElement => {
    const { name, extension } = parse(file);
    return (
        <div className={classnames(styles.fileNameBody, { [styles.fileNameBodyMedium]: isSizeMedium })}>
            <div className={styles.fileName}>{name}</div>
            {extension && <div>.{extension}</div>}
        </div>
    );
};

export { FileName };
